import type { Product } from '../generated/graphql'

export function getIsFreeClaim(product: Product) {
  return !!product.whitelistable
}
